import request from '@/utils/request'

// 精选列表
export const selectedListData = params => {
  return request({
    url: 'app/media/hostList',
    method: 'get',
    params
  })
}

// 根据剧集id获取防盗链
export const getVideoData = params => {
  return request({
    url: '/app/media/getFdUrl',
    method: 'get',
    params
  })
}

// 新增观看历史记录
export const addHistoryData = data => {
  return request({
    url: '/app/history/addOrUpd',
    method: 'post',
    data
  })
}

// 观看历史
export const getHistoryData = params => {
  return request({
    url: '/app/history/list',
    method: 'get',
    params
  })
}

// 注册
export const registerApi = (data) => {
  return request({
    url: '/xy/phoneRegis',
    method: 'post',
    data
  })
}

// 登录
export const loginApi = (data) => {
  return request({
    url: '/xy/login',
    method: 'post',
    data
  })
}

// 发送验证码
export const getCodeApi = phone => {
  return request({
    url: '/xy/sendSMS/' + phone,
    method: 'get'
  })
}